import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  loginWithPassword,
  logout,
  resendForgotOtp,
  resendLoginOtp,
  resetPassword,
  sendForgotOtp,
  sendLoginOtp,
  setActivationPassword,
  verifyForgotOtp,
  verifyLoginOtp,
} from './api';
import type { AuthSuccess, LoginVerifyResult } from './types';

export const authKeys = { all: ['auth'] as const, me: () => [...authKeys.all, 'me'] as const };

export function useLoginPassword() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: loginWithPassword,
    onSuccess: (d: AuthSuccess) => qc.setQueryData(authKeys.me(), d.user),
  });
}
export function useSendLoginOtp() {
  return useMutation({ mutationFn: sendLoginOtp });
}
export function useVerifyLoginOtp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: verifyLoginOtp,
    // Only the session arm has a user. Seeding `me` on the activation arm would write `undefined`
    // and hand <AuthProvider> a half-authenticated state (ADO 117536).
    onSuccess: (result: LoginVerifyResult) => {
      if (result.kind === 'session') qc.setQueryData(authKeys.me(), result.user);
    },
  });
}
export function useSendForgotOtp() {
  return useMutation({ mutationFn: (phone: string) => sendForgotOtp(phone) });
}
export function useResendLoginOtp() {
  return useMutation({ mutationFn: (referenceId: string) => resendLoginOtp(referenceId) });
}
export function useResendForgotOtp() {
  return useMutation({ mutationFn: (referenceId: string) => resendForgotOtp(referenceId) });
}
export function useVerifyForgotOtp() {
  return useMutation({ mutationFn: verifyForgotOtp });
}
export function useSetActivationPassword() {
  return useMutation({ mutationFn: setActivationPassword });
}
export function useResetPassword() {
  return useMutation({ mutationFn: (newPassword: string) => resetPassword(newPassword) });
}
export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: logout,
    onSuccess: () => qc.removeQueries({ queryKey: authKeys.all }),
  });
}
